import React from "react";
import { notifyBugsnag } from "../../bugsnag";
import { assetUrl } from "../../utils/assetUrl";

const FLAG_URLS = import.meta.glob<string>("/node_modules/country-flag-icons/3x2/*.svg", {
  query: "?url&no-inline",
  import: "default",
  eager: true,
});

export function buildFlagUrlsByCode(flagUrls: Record<string, string>): Record<string, string> {
  const urlsByCode = Object.entries(flagUrls).reduce<Record<string, string>>((flags, [path, url]) => {
    const filename = path.slice(path.lastIndexOf("/") + 1);
    const code = filename.slice(0, -4).toUpperCase();
    flags[code] = url;
    return flags;
  }, {});

  if (Object.keys(urlsByCode).length === 0) {
    notifyBugsnag(new Error("Country flag SVG map is empty"), {
      component: "CountryFlag",
    });
  }

  return urlsByCode;
}

const FLAG_URLS_BY_CODE = buildFlagUrlsByCode(FLAG_URLS);

interface CountryFlagProps {
  readonly code: string;
}

function CountryFlag({ code }: CountryFlagProps): React.ReactElement | null {
  const url = FLAG_URLS_BY_CODE[code.toUpperCase()];
  if (!url) return null;

  return (
    <img src={assetUrl(url)} alt="" aria-hidden="true" width={20} height={14} loading="lazy" className="gcw:shrink-0" />
  );
}

export default CountryFlag;
